<template>
  <div class="filters">
    <div id="superiorAssessmentFormList">
      <div class="recordList">
        <el-table :data="orderList" class="wid100" :row-class-name="tableRowClassName"
          :height="orderList.length > 0 ? require('@/config/enum').tableheight530 : require('@/config/enum').tableheight109">
          <el-table-column prop="Id" label="序号" width="100px">
          </el-table-column>
          <el-table-column prop="IdNo" label="姓名">
          </el-table-column>
          <el-table-column prop="State" label="状态">
            <template slot-scope="scope">
            <span v-if="scope.row.State === 1">已确定1</span>
            <span v-if="scope.row.State === 2">未确定</span>
            <span v-if="scope.row.State === 3">已确定</span>
          </template>
          </el-table-column>
          <el-table-column prop="operation" :label="$t('lang.lab_operation')" width="200">
          <template slot-scope="scope">
            <el-button @click="operation(scope.row.id)">评审</el-button>
          </template>
        </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
          :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :page-count="pageCount" />
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        pageCount: 0, // 总数
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        orderList: [], //缴费记录列表
        staffId: 100104, //人员id
      }
    },
    computed: {
      // ...mapGetters({ staffId: 'staffId', gardenId: 'gardenId' })
    },
    methods: {
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getList()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getList()
      },
      // 评审
      operation(id){
        this.$router.push({
          name: 'superiorAssessmentForm'
        })
      },
      // 员工自评列表
      getList(){
        let loading = this.$loading()
        this.$get(`/getChildEmpAssessmentFormListByStaffId?pageNo=${this.pageNo}&pageSize=${this.pageSize}&staffId=${this.staffId}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.orderList = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      
    },
    mounted() {
      // 获取员工自评列表数据
      this.getList()

    }
  }
</script>
<style lang="scss">
  #superiorAssessmentFormList {
    .recordList {
      margin-top: 30px;
    }

    .recordList .el-table td,
    .recordList .el-table th {
      text-align: center;
    }
  }
</style>